import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Tabs from "../../../components/common/Tabs";

const tabs = [
  {
    link: "/accounting/payables_bills/bills",
    title: "Bills",
  },
  {
    link: "/accounting/payables_bills/payments",
    title: "Payments",
  },
  {
    link: "/accounting/payables_bills/recurring_invoices",
    title: "Recurring",
  },
  {
    link: "/accounting/payables_bills/payment_batches",
    title: "Payment Batches",
  },
];

function Payables() {
  const location = useLocation();
  console.log(location.pathname);
  return (
    <>
      {location.pathname === "/accounting/payables_bills/paybills" ? null : (
        <Tabs tabs={tabs} />
      )}
      <Outlet />
    </>
  );
}

export default Payables;
